// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"62e4331e","488":"ace81a48"}[chunkId] + ".chunk.js";
};